module.exports = __webpack_public_path__ + "img/1519279923.e72467eb.jpg";